import React, { Component} from "react";
// Styles
import "./WelcomeView.scss";


// Components
import HeaderView from "components/HeaderView";
// import Next from 'static/img/next.svg'
import  Welcome from "views/Welcome/Welcome";

class WelcomeView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      < Welcome>
       </Welcome>
    </div>
      </>
    );
  }
}
export default WelcomeView;
